"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const menuItems = [{
  label: "Qui suis-je ?",
  href: "/WhoAmIPage"
}, {
  label: "Certifications RNCP RS",
  href: "/RncpRsCertificationsPage"
}, {
  label: "Certification Qualiopi®",
  href: "/ProfessionalTrainingQualityPage"
}, {
  label: "Cadre juridique de la formation professionnelle",
  href: "/TrainingLegalFrameworkPage"
}, {
  label: "Blog",
  href: "https://effet-conseil.com/category/blog/"
}, {
  label: "Contact",
  href: "/ContactPage"
}];
const schemaMarkup = {
  "@context": "https://schema.org",
  "@graph": [{
    "@type": "Organization",
    "@id": "https://effet-conseil.com/#organization",
    name: "Effet Conseil",
    url: "https://effet-conseil.com",
    logo: {
      "@type": "ImageObject",
      url: "https://effet-conseil.com/wp-content/uploads/2026/04/Logo-Bureautique-EFFET-CONSEIL-Q-sans-fond.png"
    },
    founder: {
      "@id": "https://effet-conseil.com/#christelle"
    },
    sameAs: ["https://fr.linkedin.com/in/christellecharrier-robelin"]
  }, {
    "@type": "Person",
    "@id": "https://effet-conseil.com/#christelle",
    name: "Christelle CHARRIER-ROBELIN",
    jobTitle: "Fondatrice & Consultante experte en formation professionnelle",
    url: "https://effet-conseil.com/qui-suis-je/",
    image: "https://working-starling.10web.cloud/wp-content/uploads/2026/03/image_gy8r7uz5.jpg",
    worksFor: {
      "@id": "https://effet-conseil.com/#organization"
    },
    sameAs: ["https://fr.linkedin.com/in/christellecharrier-robelin"],
    knowsAbout: ["Certifications RNCP", "Certifications RS", "Qualiopi", "Formation professionnelle", "Conformité réglementaire", "France Compétences"]
  }, {
    "@type": "WebSite",
    "@id": "https://effet-conseil.com/#website",
    name: "Effet Conseil",
    url: "https://effet-conseil.com",
    publisher: {
      "@id": "https://effet-conseil.com/#organization"
    }
  }, {
    "@type": "WebPage",
    "@id": "https://effet-conseil.com/#webpage",
    url: "https://effet-conseil.com",
    name: "Effet Conseil – Certifications RNCP/RS, Qualiopi®, conformité réglementaire",
    description: "Effet Conseil – Cabinet fondé par Christelle CHARRIER-ROBELIN. Accompagnement en certifications RNCP/RS, Qualiopi® et conformité réglementaire de la formation professionnelle.",
    isPartOf: {
      "@id": "https://effet-conseil.com/#website"
    },
    about: {
      "@id": "https://effet-conseil.com/#organization"
    }
  }]
};
export default function EnTeteDeNavigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (hashPart === '') {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schemaMarkup)
    }} />

      <header id="header" className={cn("sticky top-0 z-50 w-full transition-all duration-300 border-b", isScrolled ? "bg-background/80 backdrop-blur-md border-border shadow-md" : "bg-background border-border/50")}>
        <div className="container mx-auto px-4 h-16 md:h-20 flex items-center justify-between gap-4">
          <Link to="/HomePage" className="flex-shrink-0 z-50 block" aria-label="Accueil EffetConseil">
            <img src="https://effet-conseil.com/wp-content/uploads/2026/04/Logo-Bureautique-EFFET-CONSEIL-Q-sans-fond.png" alt="Logo Effet Conseil – Cabinet de conseil en formation professionnelle" className="h-10 md:h-12 w-auto object-contain" />
          </Link>

          <div className="hidden lg:flex flex-1 justify-center">
            <NavigationMenu>
              <NavigationMenuList>
                {menuItems.map(item => <NavigationMenuItem key={item.label}>
                    <NavigationMenuLink asChild>
                      {item.href.startsWith("http") ? <a href={item.href} className={cn(navigationMenuTriggerStyle(), "bg-transparent hover:bg-transparent font-serif font-medium text-foreground hover:text-foreground relative hover:underline decoration-2 underline-offset-8 decoration-secondary transition-all")}>
                          {item.label}
                        </a> : <Link to={item.href} className={cn(navigationMenuTriggerStyle(), "bg-transparent hover:bg-transparent font-serif font-medium text-foreground hover:text-foreground relative hover:underline decoration-2 underline-offset-8 decoration-secondary transition-all")}>
                          {item.label}
                        </Link>}
                    </NavigationMenuLink>
                  </NavigationMenuItem>)}
              </NavigationMenuList>
            </NavigationMenu>
          </div>

          <div className="flex items-center">
            <Button variant="ghost" size="icon" className="lg:hidden text-foreground hover:bg-accent/50 rounded-sm" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Menu">
              {isMobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
            </Button>
          </div>
        </div>

        {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 w-full bg-background border-b border-border shadow-xl max-h-[calc(100vh-5rem)] overflow-y-auto animate-in slide-in-from-top-5 duration-200">
            <nav className="flex flex-col space-y-1 p-4">
              {menuItems.map(item => item.href.startsWith("http") ? <a key={item.label} href={item.href} className="block px-4 py-2 text-sm font-serif font-medium hover:bg-accent hover:text-foreground rounded-sm transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                    {item.label}
                  </a> : <Link key={item.label} to={item.href} className="block px-4 py-2 text-sm font-serif font-medium hover:bg-accent hover:text-foreground rounded-sm transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                    {item.label}
                  </Link>)}
            </nav>
          </div>}
      </header>
    </>;
}